import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeading from './SectionHeading';
import { getLocaleList } from '../utils/localeList';
import useReveal from '../hooks/useReveal';

/**
 * Section 04 — the AI consulting line.
 *
 * Sits right after "What we do" because both sections answer the same question
 * ("what can you do for me?") and the visitor should read them as one offer
 * with two halves, not as two unrelated businesses. The intro carries that
 * join: it's the same product logic, pointed at AI instead of at chain.
 *
 * Cards are name + description only. The blockchain stages next door earn their
 * service lists because the visitor is choosing between four entry points; here
 * the six offerings are a catalogue, and a second level of detail on each would
 * bury the one line that matters.
 */
const AiConsulting = () => {
  const { t } = useTranslation();
  const reveal = useReveal();
  const services = getLocaleList(t, 'aiConsulting.services');

  return (
    <div id="ai-consulting" className="mainCont relative z-30 pt-5 mt-[100px] lg4:mt-[150px]" ref={reveal} data-reveal>
      <SectionHeading
        eyebrow={t('aiConsulting.eyebrow')}
        title={t('aiConsulting.title')}
        intro={t('aiConsulting.intro')}
        image="/images/ai-paltalabs.png"
      />

      <div className="grid grid-cols-1 md2:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((service) => (
          <div
            key={service.name}
            className="landingCard p-6 flex flex-col"
          >
            <div className="font-grotesk text-[20px] font-bold text-main leading-[125%]">
              {service.name}
            </div>
            <p className="text-main-gray text-sm mt-4 border-t border-white/10 pt-4">
              {service.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AiConsulting;
